import { call, takeLatest, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import apiRequest from '../api/api.request';
import endpoints from '../../../constants/endpoints';
import {
	setNewPasswordAction,
	setChangePasswordSuccesAction,
	setErrorChangePasswordAction,
	ISetNewPasswordRequest,
} from '../actions/ChangePasswordAction';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';

function* setNewPassword({
	payload,
}: {
	payload: ISetNewPasswordRequest;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.SET_CHANGE_PASSWORD,
		method: 'PUT',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: null,
		body: payload,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		yield put(setChangePasswordSuccesAction('success'));
		return res;
	} catch (err) {
		yield put(setErrorChangePasswordAction(err as string));
		return err;
	}
}

function successSetNewPassword({ payload }: { payload: string }): string {
	toast.success('Berhasil mengubah kata sandi');
	return payload;
}

function errorSetNewPassword({ payload }: { payload: string }): string {
	toast.error('Gagal mengubah kata sandi. Silahkan coba lagi');
	return payload;
}

export default function* changePasswordSaga(): Generator {
	yield takeLatest(setNewPasswordAction, setNewPassword);
	yield takeEvery(setChangePasswordSuccesAction, successSetNewPassword);
	yield takeEvery(setErrorChangePasswordAction, errorSetNewPassword);
}
